import React from 'react'
import { Image } from 'react-native'
import { decode } from 'blurhash'
import { getImgFromArr } from 'utils/arrayToImage'
import { getBlurhash } from 'utils/blurhash'
import { ImageBlurhashProps } from 'types'

const ImageBlurhash = ({
  object,
  source,
  componentProps,
  layout,
}: ImageBlurhashProps) => {
  if (!layout) {
    return null
  }

  const blurhash = getBlurhash(object, source, componentProps)

  if (!blurhash) {
    return null
  }

  const { blurHash, blurHashWidth, blurHashHeight, resizeMode } = blurhash

  const pixels = decode(blurHash, blurHashWidth, blurHashHeight)
  const image = getImgFromArr(pixels, blurHashWidth, blurHashHeight)
  const { src } = image

  return (
    <Image
      source={{ uri: src }}
      style={{ width: layout.width, height: layout.height }}
      resizeMode={resizeMode}
    />
  )
}

export default ImageBlurhash
